export function InsertAnchor (pEditor, pAnchor)
{
  this.queryOpenInsertAnchorDialogEnabled = (pButton, command) =>
  {
    return ((BEditor.browser.isIE) ? true : pEditor.queryBasicCommandEnabled(pButton, 'inserthtml'));
  };


  this.openInsertAnchorDialog = (pButton) =>
  {
    pEditor.pDialog = pButton.getDialog();

    var anchorIndex = pAnchor.getAnchorIndex();

    if (anchorIndex == null)
    {
      var checkParentTagA = /^a$/i;
      var currentSelection = pEditor.range.selection.getCurrent();
      var currentRange = pEditor.range.getCurrent();

      if (currentSelection && currentRange)
      {
        var parentElementA = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

        if (parentElementA)
        {
          if (BEditor.browser.isIE)
          {
            currentRange.moveToElementText(parentElementA);
            var movedCharacters, parentElement;

            do
            {
              currentRange.collapse(true);
              movedCharacters = currentRange.move('character', -1);
              parentElement = currentRange.parentElement();
            }
            while (parentElement == parentElementA && movedCharacters);

            currentRange.collapse(true);

            if (movedCharacters)
            {
              currentRange.move('character', 1);
            }
          }
          else
          {
            currentRange.selectNode(parentElementA);
            currentRange.collapse(true);
          }
        }
        else
        {
          if (!currentSelection || !currentSelection.type || !currentSelection.type.toUpperCase || currentSelection.type.toUpperCase() != 'CONTROL')
          {
            currentRange.collapse(true);
          }
        }

        if (!BEditor.browser.isIE)
        {
          currentSelection.collapse(currentRange.startContainer, currentRange.startOffset);
        }
      }

      anchorIndex = pAnchor.getAnchorIndex();
    }

    pEditor.range.save();

    const name = (anchorIndex != null && pAnchor.allAnchors[anchorIndex]) ? pAnchor.allAnchors[anchorIndex].name : '';
    const index = (anchorIndex != null && pAnchor.allAnchors[anchorIndex]) ? anchorIndex : null;

    window.BEditor.openDialog('openInsertAnchorDialog', function(params) { pEditor.pThis.execCommand(pButton, 'insertAnchor', params); },  function() { pAnchor.currentAnchorIndex = null; pEditor.afterCloseDialog(); }, { name, index, isEditMode: index !== null } );
    pEditor.afterOpenDialog();
  };


  this.insertAnchor = (pButton, pParameters) =>
  {
    var i, imgs, attrIndex;
    var anchorIndex;
    var anchorName;
    var anchorVisualTag;
    var currentSelection, currentRange;

      if (pParameters)
      {
        anchorName = pParameters.name;

        if (anchorName == null || anchorName.trim() === '')
        {
          pEditor.afterCloseDialog();
          return false;
        }

        anchorIndex = pParameters.anchorIndex;

        if (anchorIndex == null || isNaN(anchorIndex) || !pAnchor.allAnchors[anchorIndex])
        {
          anchorIndex = pAnchor.allAnchors.length;
          pAnchor.allAnchors[anchorIndex] = {};
          pAnchor.allAnchors[anchorIndex].name = anchorName;

          anchorVisualTag = '<img src="/Admin/html_res/images/editor-in-anchor.gif?' + BEditor.environment.version + '" ';
          anchorVisualTag += 'data-anchorIndex="UserCustomAnchor-' + anchorIndex + '" alt="' + anchorName + '" title="' + anchorName + '" ';
          anchorVisualTag += 'border="0" class="anchorInEditor" style="border: 0; border: none; background: none; margin: 0; padding: 0;">';
        }
      }

      pEditor.afterCloseDialog();

      if (anchorVisualTag)
      {
        currentSelection = pEditor.range.selection.getCurrent();
        currentRange = pEditor.range.getCurrent();

        if (currentSelection && currentRange)
        {
          if (BEditor.browser.isIE)
          {
            var checkParentTagA = /^a$/i;
            var parentElementA = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

            if (parentElementA)
            {
              var tempNode = pEditor.iFrameDoc.createElement('SPAN');
              tempNode.innerHTML = '&nbsp;';
              parentElementA.parentNode.insertBefore(tempNode, parentElementA);
              currentRange.moveToElementText(tempNode);
              tempNode.removeNode(false);
              currentRange.select();
            }
          }

          pEditor.helpers.insertHTML(anchorVisualTag);
        }
      }
      else
      {
        pAnchor.allAnchors[anchorIndex].name = anchorName;

        imgs = pEditor.iFrameDoc.getElementsByTagName('IMG');

        for (i = 0; i < imgs.length; i++)
        {
          attrIndex = imgs[i].getAttribute('data-anchorIndex', 0);

          if (attrIndex)
          {
            attrIndex = attrIndex.replace(/UserCustomAnchor-(\d+)/i, '$1');

            if (attrIndex == anchorIndex)
            {
              imgs[i].setAttribute('alt', anchorName, 0);
              imgs[i].setAttribute('title', anchorName, 0);
              break;
            }
          }
        }

        pAnchor.currentAnchorIndex = null;
      }
  };
}